import { render, staticRenderFns } from "./zdysjlList.vue?vue&type=template&id=1d653f83"
import script from "./zdysjlList.vue?vue&type=script&lang=js"
export * from "./zdysjlList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports